import { Instance } from 'mobx-state-tree'
import { SetUserRolesResultModelBase } from './SetUserRolesResultModel.base'

/* The TypeScript type of an instance of SetUserRolesResultModel */
export interface SetUserRolesResultModelType extends Instance<typeof SetUserRolesResultModel.Type> {}

/* A graphql query fragment builders for SetUserRolesResultModel */
export {
  selectFromSetUserRolesResult,
  setUserRolesResultModelPrimitives,
  SetUserRolesResultModelSelector
} from './SetUserRolesResultModel.base'

/**
 * SetUserRolesResultModel
 */
export const SetUserRolesResultModel = SetUserRolesResultModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
